// extracted by mini-css-extract-plugin
export default {"text":"Calendar_text__Mh5sG","popper":"Calendar_popper__iadi0","icon":"Calendar_icon__ev07y"};